var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"reply-to-container",class:{
      'incoming-message': _vm.messageType === _vm.MESSAGE_TYPE.INCOMING,
      'outgoing-message': _vm.messageType === _vm.MESSAGE_TYPE.OUTGOING,
      'no-attachments': !_vm.parentHasAttachments,
      'not-clickable': !_vm.hasMessage,
    },on:{"click":_vm.scrollToMessage}},[_c('message-preview',{attrs:{"message":_vm.message,"show-message-type":true,"default-empty-message":_vm.$t('CONVERSATION.REPLY_MESSAGE_NOT_FOUND')}})],1),_vm._v(" "),_c('div',{staticClass:"separator"})])}
var staticRenderFns = []

export { render, staticRenderFns }